import { charlotteMediaArray } from './charlotteMedia'
import { charlotteBio } from './charlotteBios'

import { carrieReviewerReviewHinge, mirandaReviewerReviewBumble, samanthaReviewerReviewTinder } from './charlotteReviewerReviews'
import { carrieReviewerProfile, mirandaReviewerProfile, samanthaReviewerProfile } from './charlotteReviewers'

export const carrieProfileReviewHinge = {
  _id: 'carrieProfileReviewHingeId',
  userId: 'charlotteUserId',
  userEmail: 'charlotte@email.com',
  datingProfileId: 'charlotteDatingProfileHingeId',
  reviewerProfileId: 'carrieReviewerProfileId',
  reviewerEmail: 'carrie@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: charlotteMediaArray[0]._id,
      mediaItemURL: charlotteMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[0].type,
      caption: charlotteMediaArray[0].captions[1],
      subcaption: charlotteMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[4]._id,
      mediaItemURL: charlotteMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[4].type,
      caption: charlotteMediaArray[4].captions[1],
      subcaption: charlotteMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[7]._id,
      mediaItemURL: charlotteMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[7].type,
      caption: charlotteMediaArray[7].captions[1],
      subcaption: charlotteMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[9]._id,
      mediaItemURL: charlotteMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[9].type,
      caption: charlotteMediaArray[9].captions[1],
      subcaption: charlotteMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[6]._id,
      mediaItemURL: charlotteMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[6].type,
      caption: charlotteMediaArray[6].captions[2],
      subcaption: charlotteMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[5]._id,
      mediaItemURL: charlotteMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[5].type,
      caption: charlotteMediaArray[5].captions[0],
      subcaption: charlotteMediaArray[5].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the black, the earrings, and the gallery background! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `How do you say poor guys stay away without saying poor guys stay away`,
      verdict: 'Very',
    },
    {
      feedback: `Love it! After the two fancier photos, you cut the tension with something more casual. Love the expression`,
      verdict: 'Yes',
    },
    {
      feedback: `Yes! Show off your fabulous friends! Social proof if I've ever seen it!`,
      verdict: 'Yes',
    },
    {
      feedback: `Action shot! Love the smile and the activity!`,
      verdict: 'Very',
    },
    {
      feedback: `You look super classy here! And bonus points for the candidness — it doesn't look posed`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: charlotteBio._id,
    vitalInfo: { ...charlotteBio.vitalInfo },
    prompts: [
      { ...charlotteBio.prompts[0] },
      { ...charlotteBio.prompts[1] },
      { ...charlotteBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Beautiful, classy, and well educated  — The pedigree is top tier`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `OK, maybe a bit too direct. Try to be a bit more lighthearted — the seriousness shows through the joking tone`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `A bit bland. Come on, you're clever, put a witty bow on it`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is funny! And it invites the Carters and the Parkers that you're after`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Charlotte is very pretty, classy, and of top pedigree.`,
    good: `You're obviously super classy and well put-together. Your photos are awesome!`,
    notGood: `The prompts could be a bit wittier`,
    verdict: `Overall the profile definitely displays an attractive Charlotte. Just change add in some snazzier prompts and you'll get your choice of all the Parkers, Carters, and Bradys in New York`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...carrieReviewerReviewHinge },
  reviewerProfile: { ...carrieReviewerProfile },
  bioItems: { ...charlotteBio },
  mediaItems: [ ...charlotteMediaArray ],
}

export const mirandaProfileReviewBumble = {
  _id: 'mirandaProfileReviewBumbleId',
  userId: 'charlotteUserId',
  userEmail: 'charlotte@email.com',
  datingProfileId: 'charlotteDatingProfileBumbleId',
  reviewerProfileId: 'mirandaReviewerProfileId',
  reviewerEmail: 'miranda@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: charlotteMediaArray[0]._id,
      mediaItemURL: charlotteMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[0].type,
      caption: charlotteMediaArray[0].captions[1],
      subcaption: charlotteMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[4]._id,
      mediaItemURL: charlotteMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[4].type,
      caption: charlotteMediaArray[4].captions[1],
      subcaption: charlotteMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[7]._id,
      mediaItemURL: charlotteMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[7].type,
      caption: charlotteMediaArray[7].captions[1],
      subcaption: charlotteMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[9]._id,
      mediaItemURL: charlotteMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[9].type,
      caption: charlotteMediaArray[9].captions[1],
      subcaption: charlotteMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[6]._id,
      mediaItemURL: charlotteMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[6].type,
      caption: charlotteMediaArray[6].captions[2],
      subcaption: charlotteMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[5]._id,
      mediaItemURL: charlotteMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[5].type,
      caption: charlotteMediaArray[5].captions[0],
      subcaption: charlotteMediaArray[5].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the black, the earrings, and the gallery background! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `How do you say poor guys stay away without saying poor guys stay away`,
      verdict: 'Very',
    },
    {
      feedback: `Love it! After the two fancier photos, you cut the tension with something more casual. Love the expression`,
      verdict: 'Yes',
    },
    {
      feedback: `Yes! Show off your fabulous friends! Social proof if I've ever seen it!`,
      verdict: 'Yes',
    },
    {
      feedback: `Action shot! Love the smile and the activity!`,
      verdict: 'Very',
    },
    {
      feedback: `You look super classy here! And bonus points for the candidness — it doesn't look posed`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: charlotteBio._id,
    vitalInfo: { ...charlotteBio.vitalInfo },
    prompts: [
      { ...charlotteBio.prompts[0] },
      { ...charlotteBio.prompts[1] },
      { ...charlotteBio.prompts[2] }
    ],
    aboutMe: charlotteBio.aboutMe[0],
    hobbies: [charlotteBio.hobbies[0], charlotteBio.hobbies[1], charlotteBio.hobbies[2], charlotteBio.hobbies[3], charlotteBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Beautiful, classy, and well educated  — The pedigree is top tier`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'Love the narrative nature of it!',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `OK, maybe a bit too direct. Try to be a bit more lighthearted — the seriousness shows through the joking tone`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `A bit bland. Come on, you're clever, put a witty bow on it`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is funny! And it invites the Carters and the Parkers that you're after`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Charlotte is very pretty, classy, and of top pedigree.`,
    good: `You're obviously super classy and well put-together. Your photos are awesome!`,
    notGood: `The prompts could be a bit wittier`,
    verdict: `Overall the profile definitely displays an attractive Charlotte. Just change add in some snazzier prompts and you'll get your choice of all the Parkers, Carters, and Bradys in New York`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...mirandaReviewerReviewBumble },
  reviewerProfile: { ...mirandaReviewerProfile },
  bioItems: { ...charlotteBio },
  mediaItems: [ ...charlotteMediaArray ],
}

export const samanthaProfileReviewTinder = {
  _id: 'samanthaProfileReviewTinderId',
  userId: 'charlotteUserId',
  userEmail: 'charlotte@email.com',
  datingProfileId: 'charlotteDatingProfileTinderId',
  reviewerProfileId: 'samanthaReviewerProfileId',
  reviewerEmail: 'samantha@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: charlotteMediaArray[0]._id,
      mediaItemURL: charlotteMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[0].type,
      caption: charlotteMediaArray[0].captions[1],
      subcaption: charlotteMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[4]._id,
      mediaItemURL: charlotteMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[4].type,
      caption: charlotteMediaArray[4].captions[1],
      subcaption: charlotteMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[7]._id,
      mediaItemURL: charlotteMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[7].type,
      caption: charlotteMediaArray[7].captions[1],
      subcaption: charlotteMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[9]._id,
      mediaItemURL: charlotteMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[9].type,
      caption: charlotteMediaArray[9].captions[1],
      subcaption: charlotteMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[6]._id,
      mediaItemURL: charlotteMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[6].type,
      caption: charlotteMediaArray[6].captions[2],
      subcaption: charlotteMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: charlotteMediaArray[5]._id,
      mediaItemURL: charlotteMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: charlotteMediaArray[5].type,
      caption: charlotteMediaArray[5].captions[0],
      subcaption: charlotteMediaArray[5].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look great here! Love the black, the earrings, and the gallery background! Great start!`,
      verdict: 'Very',
    },
    {
      feedback: `How do you say poor guys stay away without saying poor guys stay away`,
      verdict: 'Very',
    },
    {
      feedback: `Love it! After the two fancier photos, you cut the tension with something more casual. Love the expression`,
      verdict: 'Yes',
    },
    {
      feedback: `Yes! Show off your fabulous friends! Social proof if I've ever seen it!`,
      verdict: 'Yes',
    },
    {
      feedback: `Action shot! Love the smile and the activity!`,
      verdict: 'Very',
    },
    {
      feedback: `You look super classy here! And bonus points for the candidness — it doesn't look posed`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: charlotteBio._id,
    vitalInfo: { ...charlotteBio.vitalInfo },
    prompts: [
      { ...charlotteBio.prompts[0] },
      { ...charlotteBio.prompts[1] },
      { ...charlotteBio.prompts[2] }
    ],
    aboutMe: charlotteBio.aboutMe[0],
    hobbies: [charlotteBio.hobbies[0], charlotteBio.hobbies[1], charlotteBio.hobbies[2], charlotteBio.hobbies[3], charlotteBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Beautiful, classy, and well educated  — The pedigree is top tier`,
      verdict: 'Very', 
    },
    aboutMeFeedback: {
      feedback: 'Love the narrative nature of it!',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `OK, maybe a bit too direct. Try to be a bit more lighthearted — the seriousness shows through the joking tone`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `A bit bland. Come on, you're clever, put a witty bow on it`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is funny! And it invites the Carters and the Parkers that you're after`,
        verdict: 'Very', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Charlotte is very pretty, classy, and of top pedigree.`,
    good: `You're obviously super classy and well put-together. Your photos are awesome!`,
    notGood: `The prompts could be a bit wittier`,
    verdict: `Overall the profile definitely displays an attractive Charlotte. Just change add in some snazzier prompts and you'll get your choice of all the Parkers, Carters, and Bradys in New York`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...samanthaReviewerReviewTinder },
  reviewerProfile: { ...samanthaReviewerProfile },
  bioItems: { ...charlotteBio },
  mediaItems: [ ...charlotteMediaArray ],
}